import { css, styled } from '@mui/material';

import { Link } from '../Link';
import { sectionMessageLinkClasses } from './theme';

import type { SectionMessageLinkOwnerState, SectionMessageLinkProps } from './types';

const SectionMessageLink = (props: SectionMessageLinkProps) => {
  const {
    children,
    external = true, // theme defaultProps에서 이동
    ...others
  } = props;

  const ownerState: SectionMessageLinkOwnerState = {
    ...props,
    external,
  };

  return (
    <SectionMessageLinkRoot external={external} ownerState={ownerState} {...others}>
      {children}
    </SectionMessageLinkRoot>
  );
};

export default SectionMessageLink;

// Styled Components
const SectionMessageLinkRoot = styled(Link, {
  target: sectionMessageLinkClasses.root,
})<{ ownerState: SectionMessageLinkOwnerState }>(
  () => css`
    margin-top: 4px;
  `,
);
